import { Link } from "react-router-dom";
import "./not-found.css";

const NotFound = () => {
  document.title = `Docs 404 - Not found`;
  return (
    <main className="main-404">
      <section className="section-404">
        <span>404</span>
        <p>The requested path could not be found</p>
        <Link to="/" className="back-404">
          home
        </Link>
      </section>
      <section className="section-404-ads">
        <div>
          New Latest API release : -{" "}
          <Link to="/web-otp" className="back-404">
            Compression Streams API
          </Link>
        </div>
      </section>
    </main>
  );
};

export default NotFound;
